import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { userService } from "../../../../api/user";
import { uploadService } from "../../../../api/upload";
import './FoodTemplate1.css';

const FoodTemplate1 = () => {
   const { id } = useParams();
   const navigate = useNavigate();
   const initialCanEdit = id === 'new'; // Determine initial canEdit based on ID
   const [isEditMode, setIsEditMode] = useState(initialCanEdit);
   const [isHeaderActive, setIsHeaderActive] = useState(false);
   const [isNavbarActive, setIsNavbarActive] = useState(false);
   const [showPublishModal, setShowPublishModal] = useState(false);
   const [isPublishing, setIsPublishing] = useState(false);
   const [isSaving, setIsSaving] = useState(false);
   const [loading, setLoading] = useState(true);
   const [canEdit, setCanEdit] = useState(initialCanEdit); // Initialize with initialCanEdit

   const fileInputRef = useRef(null);
   const [activeImageUploadVariables, setActiveImageUploadVariables] = useState({
      index: null,
      parentKey: null,
      childKey: null
   });

   const jwt = Cookies.get("jwt");
   const loggedInEmail = jwt ? jwtDecode(jwt)?.email : null;

   // Default Data State (Matches Foodie Master Reference)
   const [data, setData] = useState({
      hero: {
         subtitle: "Eat Sleep And",
         title: "Supper delicious Burger in town!",
         text: "Food is any substance consumed to provide nutritional support for an organism.",
         bg_image: "/assets/images/food-template-1/hero-bg.jpg",
         banner_image: "/assets/images/food-template-1/hero-banner.png"
      },
      promo: [
         {
            title: "Maxican Pizza",
            text: "Food is any substance consumed to provide.",
            image: "/assets/images/food-template-1/promo-1.png"
         },
         {
            title: "Soft Drinks",
            text: "Food is any substance consumed to provide.",
            image: "/assets/images/food-template-1/promo-2.png"
         },
         {
            title: "French Fry",
            text: "Food is any substance consumed to provide.",
            image: "/assets/images/food-template-1/promo-3.png"
         }
      ],
      about: {
         title: "Caferio, Burgers, and Best Pizzas in Town!",
         description: "The restaurants in Hangzhou also catered to many northern Chinese who had fled south from Kaifeng during the Jurchen invasion.",
         banner: "/assets/images/food-template-1/about-banner.png",
         features: [
            "Delicious & Healthy Foods",
            "Spacific Family And Kids Zone",
            "Music & Other Facilities",
            "Fastest Food Home Delivery"
         ]
      },
      menu: [
         { title: "Greek Pizza", price: "$25.50", image: "/assets/images/food-template-1/food-menu-1.png", tag: "-15%" },
         { title: "Lasagne", price: "$40.00", image: "/assets/images/food-template-1/food-menu-2.png", tag: "New" },
         { title: "Butternut Pumpkin", price: "$10.00", image: "/assets/images/food-template-1/food-menu-3.png", tag: "-5$" },
         { title: "Tokusen Wagyu", price: "$39.00", image: "/assets/images/food-template-1/food-menu-4.png", tag: "New" },
         { title: "Olivas Rellenas", price: "$25.00", image: "/assets/images/food-template-1/food-menu-5.png", tag: "-15%" },
         { title: "Opu Fish", price: "$49.00", image: "/assets/images/food-template-1/food-menu-6.png", tag: "New" }
      ],
      cta: {
         title: "The Foodie Have Excellent Of Quality Burgers!",
         text: "The restaurants in Hangzhou also catered to many northern Chinese who had fled south from Kaifeng.",
         bg_image: "/assets/images/food-template-1/cta-bg.jpg",
         banner: "/assets/images/food-template-1/cta-banner.png"
      },
      delivery: {
         title: "A Moments Of Delivered On Right Time & Place",
         text: "The restaurants in Hangzhou also catered to many northern Chinese who had fled south from Kaifeng.",
         image: "/assets/images/food-template-1/delivery-banner-bg.png",
         boy_image: "/assets/images/food-template-1/delivery-boy.svg"
      },
      banners: [
         { title: "Discount For Delicious Tasty Burgers!", text: "Sale off 50% only this week", image: "/assets/images/food-template-1/banner-1.jpg", subtitle: "50% Off Now!" },
         { title: "Delicious Pizza", text: "50% off Now", image: "/assets/images/food-template-1/banner-2.jpg", subtitle: "" },
         { title: "American Burgers", text: "50% off Now", image: "/assets/images/food-template-1/banner-3.jpg", subtitle: "" },
         { title: "Tasty Buzzed Pizza", text: "Sale off 50% only this week", image: "/assets/images/food-template-1/banner-4.jpg", subtitle: "" }
      ],
      blog: [
         { title: "What Do You Think About Cheese Pizza Recipes?", date: "Jan 01 2022", image: "/assets/images/food-template-1/blog-1.jpg", tag: "Pizza" },
         { title: "Making Chicken Strips With New Delicious Ingridents.", date: "Jan 01 2022", image: "/assets/images/food-template-1/blog-2.jpg", tag: "Burger" },
         { title: "Innovative Hot Chessyraw Pasta Make Creator Fact.", date: "Jan 01 2022", image: "/assets/images/food-template-1/blog-3.jpg", tag: "Chicken" }
      ]
   });

   // Helper: Fetch Data
   useEffect(() => {
      const loadData = async () => {
         // In a real app, we would fetch from DB here using `userService.getById(id)`
         // For now, we use the default state which mirrors the reference site
         // But we verify ownership
         if (loggedInEmail) {
            setCanEdit(true); // Simplified for demo
         }
         setLoading(false);
      };
      loadData();
   }, [id, loggedInEmail]);

   // Handle Text Changes
   const handleTextChange = (e, path) => {
      const val = e.target.value;
      setData(prev => {
         const keys = path.split('.');
         if (keys.length === 1) return { ...prev, [keys[0]]: val };
         if (keys.length === 2) return { ...prev, [keys[0]]: { ...prev[keys[0]], [keys[1]]: val } };
         if (keys.length === 3) {
            // Array handling (e.g. promo.0.title)
            const arr = [...prev[keys[0]]];
            arr[keys[1]] = { ...arr[keys[1]], [keys[2]]: val };
            return { ...prev, [keys[0]]: arr };
         }
         return prev;
      });
   };

   // Render Editable Text
   const EditableText = ({ text, path, tag: Tag = 'p', className = '' }) => {
      if (isEditMode) {
         return (
            <input
               className={`editable-text ${className}`}
               value={text}
               onChange={(e) => handleTextChange(e, path)}
            />
         );
      }
      return <Tag className={className}>{text}</Tag>;
   };

   // Handle Image Click to Trigger Upload
   const handleImageClick = (path) => {
      if (!isEditMode) return;
      const keys = path.split('.');
      if (keys.length === 3) {
         setActiveImageUploadVariables({ parentKey: keys[0], index: parseInt(keys[1]), childKey: keys[2] });
      } else {
         setActiveImageUploadVariables({ parentKey: keys[0], childKey: keys[1] });
      }
      fileInputRef.current.click();
   };

   // Handle File Selection
   const handleFileChange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      try {
         const result = await uploadService.uploadImage(file);
         setData(prev => {
            const { parentKey, index, childKey } = activeImageUploadVariables;

            // Case 1: Simple object property (e.g. hero.banner_image)
            if (index === null || index === undefined) {
               return {
                  ...prev,
                  [parentKey]: {
                     ...prev[parentKey],
                     [childKey]: result.imageUrl
                  }
               };
            }
            // Case 2: Array Item Property (e.g. promo[0].image)
            else {
               const arr = [...prev[parentKey]];
               arr[index] = { ...arr[index], [childKey]: result.imageUrl };
               return { ...prev, [parentKey]: arr };
            }
         });
      } catch (error) {
         console.error("Upload failed", error);
         alert("Failed to upload image");
      }
      e.target.value = null; // Reset input
   };

   // Render Editable Image
   const EditableImage = ({ src, alt, path, className, width, height }) => {
      return (
         <div className={`editable-image-wrapper ${isEditMode ? 'editable' : ''}`} onClick={() => handleImageClick(path)}>
            <img src={src} alt={alt} className={className} width={width} height={height} />
            {isEditMode && <div className="edit-overlay"><ion-icon name="camera"></ion-icon></div>}
         </div>
      );
   };

   // Toggle Navbar on Mobile
   const toggleNavbar = () => {
      setIsNavbarActive(!isNavbarActive);
      setIsHeaderActive(!isHeaderActive);
   };

   // Handle Publish Actions
   const handlePublish = () => {
      setIsPublishing(true);
      // Simulate API call
      setTimeout(() => {
         setIsPublishing(false);
         setShowPublishModal(true);
      }, 1500);
   };

   if (loading) return <div>Loading Template...</div>;

   return (
      <div className={`food-template-1-container ${isEditMode ? 'edit-mode-active' : ''}`}>
         <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            className="hidden-file-input"
            accept="image/*"
         />

         {/* HEADER (Simplified) */}
         <header className="header">
            <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
               <h1 className="logo">Foodie<span className="span">.</span></h1>
               <button className="btn btn-hover">Order Now</button>
            </div>
         </header>

         {/* HERO SECTION */}
         <section className="hero" id="home" style={{ backgroundImage: `url(${data.hero.bg_image})` }}>
            <div className="container">
               <div className="hero-content">
                  <EditableText tag="p" className="hero-subtitle" text={data.hero.subtitle} path="hero.subtitle" />
                  <EditableText tag="h2" className="h1 hero-title" text={data.hero.title} path="hero.title" />
                  <EditableText tag="p" className="hero-text" text={data.hero.text} path="hero.text" />
                  <button className="btn">Book A Table</button>
               </div>
               <figure className="hero-banner">
                  <EditableImage
                     src={data.hero.banner_image}
                     alt="Burger"
                     className="w-100 hero-img"
                     path="hero.banner_image"
                  />
               </figure>
            </div>
         </section>

         {/* PROMO SECTION */}
         <section className="section section-divider white promo">
            <div className="container">
               <ul className="promo-list" style={{ display: 'flex', gap: '20px', overflowX: 'auto' }}>
                  {data.promo.map((item, index) => (
                     <li key={index} className="promo-item">
                        <div className="promo-card" style={{ minWidth: '300px' }}>
                           <h3 className="h3 card-title">{item.title}</h3>
                           <p className="card-text">{item.text}</p>
                           <EditableImage
                              src={item.image}
                              width="300" height="300"
                              className="w-100 card-banner"
                              alt={item.title}
                              path={`promo.${index}.image`}
                           />
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
         </section>

         {/* ABOUT SECTION */}
         <section className="section section-divider gray about">
            <div className="container">
               <div className="about-content">
                  <h2 className="h2 section-title">{data.about.title}</h2>
                  <p className="section-text">{data.about.description}</p>
                  <ul className="about-list">
                     {data.about.features.map((feature, i) => (
                        <li key={i} className="about-item">
                           <span className="span">{feature}</span>
                        </li>
                     ))}
                  </ul>
               </div>
               <figure className="about-banner">
                  <EditableImage
                     src={data.about.banner}
                     alt="About"
                     className="w-100 about-img"
                     path="about.banner"
                  />
               </figure>
            </div>
         </section>

         {/* FOOD MENU SECTION */}
         <section className="section food-menu" id="food-menu">
            <div className="container">
               <p className="section-subtitle">Popular Dishes</p>
               <h2 className="h2 section-title">Our Delicious <span className="span">Foods</span></h2>
               <ul className="food-menu-list">
                  {data.menu.map((dish, i) => (
                     <li key={i}>
                        <div className="food-menu-card">
                           <div className="card-banner">
                              <EditableImage src={dish.image} width="80" height="80" alt={dish.title} path={`menu.${i}.image`} />
                           </div>
                           <div className="wrapper">
                              <div className="rating-wrapper"><ion-icon name="star"></ion-icon><ion-icon name="star"></ion-icon><ion-icon name="star"></ion-icon><ion-icon name="star"></ion-icon><ion-icon name="star"></ion-icon></div>
                              <h3 className="h3 card-title">{dish.title}</h3>
                              <div className="price-wrapper">
                                 <p className="price-text">Price:</p>
                                 <data className="price">{dish.price}</data>
                              </div>
                           </div>
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
         </section>

         {/* CTA SECTION */}
         <section className="section section-divider white cta" style={{ backgroundImage: `url(${data.cta.bg_image})` }}>
            <div className="container">
               <div className="cta-content">
                  <EditableText tag="h2" className="h2 section-title" text={data.cta.title} path="cta.title" />
                  <EditableText tag="p" className="section-text" text={data.cta.text} path="cta.text" />
                  <button className="btn btn-hover">Order Now</button>
               </div>
               <figure className="cta-banner">
                  <EditableImage src={data.cta.banner} width="700" height="637" className="w-100 cta-img" alt="Burger" path="cta.banner" />
               </figure>
            </div>
         </section>

         {/* DELIVERY SECTION */}
         <section className="section section-divider gray delivery">
            <div className="container">
               <div className="delivery-content">
                  <h2 className="h2 section-title">{data.delivery.title}</h2>
                  <p className="section-text">{data.delivery.text}</p>
                  <button className="btn btn-hover">Order Now</button>
               </div>
               <figure className="delivery-banner">
                  <EditableImage src={data.delivery.boy_image} width="700" height="602" className="w-100" alt="Delivery" path="delivery.boy_image" />
               </figure>
            </div>
         </section>

         {/* BANNER SECTION */}
         <section className="section section-divider white banner">
            <div className="container">
               <ul className="banner-list">
                  {data.banners.map((banner, i) => (
                     <li key={i} className="banner-card">
                        <div className="banner-img-wrapper">
                           <EditableImage src={banner.image} className="banner-img" alt={banner.title} path={`banners.${i}.image`} />
                        </div>
                        <div className="banner-item-content">
                           {banner.subtitle && <p className="banner-subtitle">{banner.subtitle}</p>}
                           <h3 className="banner-title">{banner.title}</h3>
                           <p className="banner-text">{banner.text}</p>
                           <button className="btn">Order Now</button>
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
         </section>

         {/* BLOG SECTION */}
         <section className="section section-divider gray blog" id="blog">
            <div className="container">
               <p className="section-subtitle">Latest Blog Posts</p>
               <h2 className="h2 section-title">This Is All About <span className="span">Foods</span></h2>
               <ul className="blog-list">
                  {data.blog.map((post, i) => (
                     <li key={i} className="blog-card">
                        <div className="card-banner">
                           <EditableImage src={post.image} width="600" height="390" className="w-100" alt={post.title} path={`blog.${i}.image`} />
                           <div className="badge">{post.tag}</div>
                        </div>
                        <div className="card-content">
                           <div className="card-meta-wrapper">
                              <a href="#" className="card-meta-link"><ion-icon name="calendar-outline"></ion-icon> <time className="meta-info">{post.date}</time></a>
                           </div>
                           <h3 className="h3"><a href="#" className="card-title">{post.title}</a></h3>
                           <a href="#" className="btn-link"><span>Read More</span><ion-icon name="arrow-forward" aria-hidden="true"></ion-icon></a>
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
         </section>

         {/* FOOTER */}
         <footer className="footer">
            <div className="footer-top" style={{ backgroundImage: "url('/assets/images/food-template-1/footer-illustration.png')" }}>
               <div className="container">
                  <div className="footer-brand">
                     <a href="" className="logo">Foodie<span className="span">.</span></a>
                     <p className="footer-text">Financial experts support or help you to to find out which way you can raise your funds more.</p>
                     <ul className="social-list">
                        <li><a href="#" className="social-link"><ion-icon name="logo-facebook"></ion-icon></a></li>
                        <li><a href="#" className="social-link"><ion-icon name="logo-twitter"></ion-icon></a></li>
                        <li><a href="#" className="social-link"><ion-icon name="logo-instagram"></ion-icon></a></li>
                        <li><a href="#" className="social-link"><ion-icon name="logo-pinterest"></ion-icon></a></li>
                     </ul>
                  </div>
                  <ul className="footer-list">
                     <li><p className="footer-list-title">Contact Info</p></li>
                     <li><p className="footer-list-item">+1 (062) 109-9222</p></li>
                     <li><p className="footer-list-item">Info@YourGmail24.com</p></li>
                     <li><address className="footer-list-item">153 Williamson Plaza, Maggieberg, MT 09514</address></li>
                  </ul>
               </div>
            </div>
            <div className="footer-bottom">
               <div className="container">
                  <p className="copyright-text">&copy; 2022 <a href="#" className="copyright-link">codewithsadee</a> All Rights Reserved.</p>
               </div>
            </div>
         </footer>

         {/* PUBLISH MODAL */}
         {showPublishModal && (
            <div className="publish-modal-overlay">
               <div className="publish-modal">
                  <div className="modal-icon"><ion-icon name="checkmark-circle"></ion-icon></div>
                  <h2>Website Generated!</h2>
                  <p>Your website is now live and ready to share.</p>

                  <div className="link-box">
                     <input type="text" readOnly value={`${window.location.origin}/food-template-1/live/${id}`} />
                     <button onClick={() => navigator.clipboard.writeText(`${window.location.origin}/food-template-1/live/${id}`)}>Copy</button>
                  </div>

                  <div className="qr-box">
                     <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${window.location.origin}/food-template-1/live/${id}`} alt="QR Code" />
                     <p>Scan to view on mobile</p>
                  </div>

                  <button className="btn btn-primary" onClick={() => setShowPublishModal(false)}>Close</button>
               </div>
            </div>
         )}

         {/* EDIT TOOLBAR */}
         {canEdit && (
            <div className="edit-toolbar" style={{
               position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
               background: '#1f2937', padding: '10px 20px', borderRadius: 50,
               display: 'flex', gap: 10, boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', zIndex: 9999
            }}>
               <button className="btn-small" onClick={() => setIsEditMode(!isEditMode)} style={{ color: 'white', background: 'transparent', border: '1px solid #374151', borderRadius: 20, padding: '5px 15px', cursor: 'pointer' }}>
                  <ion-icon name="eye-outline"></ion-icon> {isEditMode ? "Exit Edit Mode" : "Edit Website"}
               </button>
               <button onClick={handlePublish} className="btn-small" style={{ color: 'white', background: '#10b981', border: 'none', borderRadius: 20, padding: '5px 20px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }}>
                  {isPublishing ? <span className="loader-sm"></span> : <><ion-icon name="cloud-upload-outline"></ion-icon> Generate Website</>}
               </button>
            </div>
         )}
      </div>
   );
};

export default FoodTemplate1;
